<template>
  <div class="mb-15">
    <v-progress-linear
      v-if="!placementSetting"
      indeterminate
      color="primary"
    ></v-progress-linear>

    <template v-else>
      <div class="my-4">
        <h2 class="mb-2">① 園児 年齢ごとの設定</h2>
        <div class="setting-table-row">
          <div class="header cell-label age">年齢</div>
          <div class="header cell-label setting">設定</div>
          <div class="header cell-label calc">算式</div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">0歳児</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              保育士
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age0"
                  color="primary"
                />
              </span>
              名につき、園児
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age0"
                  color="primary"
                />
              </span>
              名
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              園児数 × {{ placementSetting.perChildren.age0 }} / {{ placementSetting.perStaff.age0 }}
            </div>
          </div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">1歳児</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              保育士
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age1"
                  color="primary"
                />
              </span>
              名につき、園児
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age1"
                  color="primary"
                />
              </span>
              名
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              園児数 × {{ placementSetting.perChildren.age1 }} / {{ placementSetting.perStaff.age1 }}
            </div>
          </div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">2歳児</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              保育士
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age2"
                  color="primary"
                />
              </span>
              名につき、園児
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age2"
                  color="primary"
                />
              </span>
              名
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              園児数 × {{ placementSetting.perChildren.age2 }} / {{ placementSetting.perStaff.age2 }}
            </div>
          </div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">3歳児</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              保育士
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age3"
                  color="primary"
                />
              </span>
              名につき、園児
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age3"
                  color="primary"
                />
              </span>
              名
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              園児数 × {{ placementSetting.perChildren.age3 }} / {{ placementSetting.perStaff.age3 }}
            </div>
          </div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">4歳児以上</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              保育士
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age4"
                  color="primary"
                />
              </span>
              名につき、園児
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age4"
                  color="primary"
                />
              </span>
              名
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              園児数 × {{ placementSetting.perChildren.age4 }} / {{ placementSetting.perStaff.age4 }}
            </div>
          </div>
        </div>

        <div class="per-age-round-row">
          <div class="per-age-round-row-header">
            <div class="setting-texts">年齢ごとの共通計算設定</div>
          </div>
          <div class="per-age-round-row-cell">
            <div class="setting-texts">
              小数点
              <span>
                <v-select
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 160px;"
                  class="mx-2"
                  v-model="placementSetting.roundingPerAge.decimalPlaces"
                  :items="[
                    { value: 1, title: '第一位' },
                    { value: 2, title: '第二位' },
                  ]"
                  color="primary"
                ></v-select>
              </span>
              を
              <span>
                <v-select
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 160px;"
                  class="mx-2"
                  v-model="placementSetting.roundingPerAge.action"
                  :items="[
                    { value: 'down', title: '切り捨て' },
                    { value: 'normal', title: '四捨五入' },
                    { value: 'up', title: '切り上げ' },
                  ]"
                  color="primary"
                ></v-select>
              </span>
            </div>
          </div>
        </div>

        <h2 class="mb-2 mt-16">② 合算</h2>
        <div class="setting-texts bold mb-4">
          ①で求めた値の小数点第一位を
          <span>
            <v-select
              variant="outlined"
              density="compact"
              hide-details
              style="width: 160px;"
              class="mx-2"
              v-model="placementSetting.roundingAll.action"
              :items="[
                { value: 'down', title: '切り捨て' },
                { value: 'normal', title: '四捨五入' },
                { value: 'up', title: '切り上げ' },
              ]"
              color="primary"
            ></v-select>
          </span>
          + {自治体加配 (③) + 配慮が必要な園児への保育者加配} = 必要保育配置者数
        </div>
        <p class="setting-texts">* 必要配置保育者数が2名未満の場合は、必要配置保育者数は2名になります。</p>

        <h2 class="mb-2 mt-16">③ 自治体加配</h2>
        <div class="per-age-round-row">
          <div class="per-age-round-row-header">
            <div class="setting-texts">自治体加配</div>
          </div>
          <div class="per-age-round-row-cell">
            <div class="setting-texts">
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.additional.staffCount"
                  color="primary"
                />
              </span>
              名
            </div>
          </div>
          <div class="per-age-round-row-header">
            <div class="setting-texts">範囲</div>
          </div>
          <div class="per-age-round-row-cell">
            <div class="setting-texts">
              <span style="width: 300px;">
                <hour-minute-input v-model="placementSetting.additional.startMin" />
              </span>
              <span class="mx-2" style="width: 40px;">から</span>
              <span style="width: 300px;">
                <hour-minute-input v-model="placementSetting.additional.endMin" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <h2 class="mb-2 mt-16">④ 配慮が必要な園児のために雇う方の時給</h2>
      <div class="per-age-round-row" style="gap: 1rem;">
        <div class="per-age-round-row-header">
          <div class="setting-texts">時給</div>
        </div>
        <div style="width: 240px;">
          <v-text-field 
            density="compact"
            hide-details
            variant="outlined"
            suffix="円"
            v-model="placementSetting.subsidyChildcare.hourlyWageAmount"
            type="number"
            color="primary"
          />
        </div>
      </div>

      <v-progress-linear
        v-if="isUpdating"
        class="my-2"
        indeterminate
        color="primary"
      ></v-progress-linear>
      
      <div class="d-flex mt-16">
        <v-spacer />
        <v-btn
          size="large"
          variant="flat"
          color="primary"
          @click="updatePlacementSetting"
        >保存</v-btn>
        <v-spacer />
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HourMinuteInput from '@/components/molecules/HourMinuteInput.vue'
import { WorkSchedulePlacementSettingResponse } from 'chaild-api/lib';
import ApiWorkSchedule from '@/api/ApiWorkSchedule'
import LocalDataService from '@/service/LocalDataService';

interface DataType {
  placementSetting: WorkSchedulePlacementSettingResponse | null;
  isUpdating: boolean;
}

export default defineComponent({
  components: {
    HourMinuteInput
  },
  data: (): DataType => ({
    placementSetting: null,
    isUpdating: false
  }),
  methods: {
    async getPlacementSetting() {
      const nurseryId = LocalDataService.getNurseryId()

      if (nurseryId) {
        const response = await ApiWorkSchedule.getPlacementSetting({ nurseryId })
        if (response) {
          this.placementSetting = response
        }
      }
    },
    async updatePlacementSetting() {
      const nurseryId = LocalDataService.getNurseryId()

      if (nurseryId && this.placementSetting) {
        this.isUpdating = true
        const response = await ApiWorkSchedule.updatePlacementSetting({
          nurseryId,
          body: this.placementSetting
        })
        this.isUpdating = false

        if (response) {
          this.placementSetting = response
        }
      }
    }
  },
  mounted() {
    this.getPlacementSetting()
  }
})
</script>

<style lang="scss" scoped>
.cell-label {
  font-size: 14px;
  &.header {
    font-weight: bold;
  }
}

.setting-table-row {
  display: flex;
  width: 100%;

  &.border {
    border-bottom: solid 1px #e0e0e0;
  }
}

.header {
  background-color: #f0f0f0;
  padding: 4px 8px;
  border-right: solid 1px #c0c0c0;

  &.age {
    width: 120px;
  }

  &.setting {
    flex: 1;
  }

  &.calc {
    width: 240px;
  }
}

.setting-cell {
  border-right: solid 1px #e0e0e0;
  padding: 16px 8px;

  &.age {
    width: 120px;
  }

  &.setting {
    flex: 1;
  }

  &.calc {
    width: 240px;
  }
}

.setting-texts {
  display: flex;
  align-items: center;
  height: 100%;
}

.per-age-round-row {
  display: flex;
  margin: .5rem 0;
}

.per-age-round-row-header {
  background-color: #f0f0f0;
  padding: 0.5rem 1rem;
  font-size: 14px;
  font-weight: bold;
}

.per-age-round-row-cell {
  padding: 0.5rem 1rem;
  font-size: 14px;
}

.bold {
  font-weight: bold;
}
</style>